"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearCheckout = exports.setSelectedBankCard = exports.setBankCards = exports.setHasBankCards = exports.setSpecialInstructions = exports.setCurrentCheckoutStep = exports.setIsGettingBranches = exports.setSelectedAddress = exports.setBranches = exports.setSelectedBranch = exports.setDeliveryOrCollection = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var react_1 = __importDefault(require("react"));
var payment_method_1 = require("../../screens/pages/checkout/steps/payment_method");
var select_address_1 = require("../../screens/pages/checkout/steps/select_address");
var select_bank_card_1 = require("../../screens/pages/checkout/steps/select_bank_card");
function getSteps(deliveryOrCollection, hasBankCards) {
    if (hasBankCards === void 0) { hasBankCards = false; }
    return [
        {
            // hidden: deliveryOrCollection == "collection",
            label: "Select Address",
            component: react_1.default.createElement(select_address_1.SelectAddressStep, null),
        },
        // {
        //   label: "Select Delivery Method & Branch",
        //   component: (
        //     <div className="flex flex-col gap-4">
        //       <DeliveryOrCollectionStep />
        //       <SelectBranchStep />
        //     </div>
        //   ),
        // },
        // {
        //   // hidden: deliveryOrCollection == "delivery",
        //   label: "Select Branch",
        //   component: ,
        // },
        {
            hidden: !hasBankCards,
            label: "Select Bank Card",
            component: react_1.default.createElement(select_bank_card_1.SelectBankCardStep, null),
        },
        // {
        //   hidden: deliveryOrCollection == "collection",
        //   label: "Special Instructions",
        //   component: <SpecialInstructionsStep />,
        // },
        {
            label: "Payment Method",
            component: react_1.default.createElement(payment_method_1.PaymentMethodStep, null),
        },
    ];
}
var initialState = {
    checkoutSteps: getSteps(),
    currentCheckoutStep: 0,
    deliveryOrCollection: "delivery",
    selectedBranch: null,
    branches: [],
    selectedAddress: null,
    hasBankCards: false,
    bankCards: [],
    selectedBankCard: null,
    isGettingBranches: false,
    specialInstructions: "",
};
var slice = (0, toolkit_1.createSlice)({
    name: "checkout",
    initialState: initialState,
    reducers: {
        setCurrentCheckoutStep: function (state, action) {
            state.currentCheckoutStep = action.payload;
        },
        setDeliveryOrCollection: function (state, action) {
            var currentState = (0, toolkit_1.current)(state);
            state.checkoutSteps = getSteps(action.payload, currentState.hasBankCards);
            state.deliveryOrCollection = action.payload;
        },
        setSelectedBranch: function (state, action) {
            var currentState = (0, toolkit_1.current)(state);
            state.checkoutSteps = getSteps(currentState.deliveryOrCollection, currentState.hasBankCards);
            state.selectedBranch = action.payload;
        },
        setBranches: function (state, action) {
            state.branches = action.payload;
        },
        setSelectedAddress: function (state, action) {
            state.selectedAddress = action.payload;
        },
        setIsGettingBranches: function (state, action) {
            state.isGettingBranches = action.payload;
        },
        setCheckoutSteps: function (state, action) {
            state.checkoutSteps = action.payload;
        },
        setSpecialInstructions: function (state, action) {
            state.specialInstructions = action.payload;
        },
        setHasBankCards: function (state, action) {
            state.hasBankCards = action.payload;
        },
        setBankCards: function (state, action) {
            state.bankCards = action.payload;
        },
        setSelectedBankCard: function (state, action) {
            state.selectedBankCard = action.payload;
        },
        clearCheckout: function (state) {
            state.currentCheckoutStep = 0;
            state.deliveryOrCollection = "";
            state.selectedBranch = null;
            state.branches = [];
            state.selectedAddress = null;
            state.bankCards = [];
            state.selectedBankCard = null;
            state.isGettingBranches = false;
            state.specialInstructions = "";
        },
        // refreshSteps: (state) => {
        //   let currentState = current(state);
        //   state.checkoutSteps = getSteps(currentState.deliveryOrCollection, currentState.hasBankCards);
        // },
    },
});
exports.setDeliveryOrCollection = (_a = slice.actions, _a.setDeliveryOrCollection), exports.setSelectedBranch = _a.setSelectedBranch, exports.setBranches = _a.setBranches, exports.setSelectedAddress = _a.setSelectedAddress, exports.setIsGettingBranches = _a.setIsGettingBranches, exports.setCurrentCheckoutStep = _a.setCurrentCheckoutStep, exports.setSpecialInstructions = _a.setSpecialInstructions, exports.setHasBankCards = _a.setHasBankCards, exports.setBankCards = _a.setBankCards, exports.setSelectedBankCard = _a.setSelectedBankCard, exports.clearCheckout = _a.clearCheckout;
exports.default = slice.reducer;
